// import ElCarouselItem from '../carousel/src/item';
import PoiCarouselItem from '../carousel/carousel/src/item';

/* istanbul ignore next */
PoiCarouselItem.install = function(Vue) {
  Vue.component(PoiCarouselItem.name, PoiCarouselItem);
};

export default PoiCarouselItem;
